import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  input: {
    marginRight: theme.spacing(3),
  },
}))
